// extracted by css-extract-rspack-plugin
export default {"username":"jAT9qU","timestamp":"N2ztLV"};